import {
  fetchSmtpSettings, fetchProductsSettings, fetchNotificationStatics,
  fetchTranslateSettings, addUpdateProductTypeSuccess, fetchMailContent,
  fetchOtpCredential, fetchCategoryOfAccount, fetchContactSettings,
  fetchContactPageSettings, fetchPrivacyPolicyPageSettings, fetchRefundPolicyPageSettings,
  fetchDisclaimerPageSettings,
  fetchTermsConditionsPageSettings, fetchServicePageSettings, fetchAboutPageSettings,
  fetchFooterPageSettings, fetchImagesOfStaticsSettings, loadImageSuccessAction,
  fetchGmailOauthSettings, fetchTransactionsSettings, fetchCaseSettings,
  fetchServicesItemEdit, addUpdateItemsSuccess, fetchThemeColorsSettings
} from "../../data-slices/admin/apiSettingsSlice";
import axios from 'utils/axios';
import { openSnackbar } from "store/state/data-slices/snackbar";

export function fetchApiSettingsApi() {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings`,
        method: 'get',
      });
      if (response.data.success) {
        dispatch(fetchTransactionsSettings(response.data?.transactions));
        dispatch(fetchGmailOauthSettings(response.data?.gmailOauth));
        dispatch(fetchProductsSettings(response.data?.products));
        dispatch(fetchSmtpSettings(response.data?.smtp));
        dispatch(fetchTranslateSettings(response.data?.translate));
        dispatch(fetchMailContent(response.data?.mailContent));
        dispatch(fetchOtpCredential(response.data?.otpCredential));
        dispatch(fetchCategoryOfAccount(response.data?.categoryOfAccount));
        dispatch(fetchContactSettings(response.data?.contact));
        dispatch(fetchNotificationStatics(response.data?.notificationStatics));
        dispatch(fetchCaseSettings(response.data?.case));
        dispatch(fetchThemeColorsSettings(response.data?.themeColors));
      }
    } catch (error: any) {
      dispatch(
        openSnackbar({
          open: true,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          message: error.message,
          variant: 'alert',
          alert: {
            color: 'error'
          }
        }));
    }
  };
}

export function getApiSettingItemsByIdApi(body: { id: number }, type: string) {
  return async (dispatch: any) => {
    try {
      const id = body.id;
      const response = await axios({
        url: `/api-settings/${type}/items/${id}`,
        method: 'get',
      });
      if (response.data.success) {
        dispatch(fetchServicesItemEdit(response.data?.data));
      } else {
        dispatch(fetchServicesItemEdit({}));
      }
    } catch (error: any) {
      dispatch(fetchServicesItemEdit({}));
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}

export function updateServicePageItemsTransApi(body: any, type: string) {
  return async (dispatch: any) => {
    try {
      const id = body?.id;
      const response = await axios({
        url: `/api-settings/${type}/items/${id}`,
        method: 'put',
        data: body

      });
      dispatch(addUpdateItemsSuccess(true));
      if (response.data.success) {
        if (body?.id) dispatch(getApiSettingItemsByIdApi({ id: Number(id) }, type));
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: response.data.message,
            variant: 'alert',
            alert: {
              color: 'success'
            }
          }));
      }
    } catch (error: any) {
      dispatch(addUpdateItemsSuccess(true));
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}

export function fetchStaticsPagesContentApi(body: { page: string }) {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/statics/${body?.page}`,
        method: 'get',
      });
      if (response.data.success) {
        if (body?.page === 'service-page') dispatch(fetchServicePageSettings(response.data?.data));
        if (body?.page === 'footer-page') dispatch(fetchFooterPageSettings(response.data?.data));
        if (body?.page === 'about-page') dispatch(fetchAboutPageSettings(response.data?.data));
        if (body?.page === 'contactPage') dispatch(fetchContactPageSettings(response.data?.data));
        if (body?.page === 'privacy-policy') dispatch(fetchPrivacyPolicyPageSettings(response.data?.data));
        if (body?.page === 'refund-policy') dispatch(fetchRefundPolicyPageSettings(response.data?.data));
        if (body?.page === 'disclaimer') dispatch(fetchDisclaimerPageSettings(response.data?.data));
        if (body?.page === 'terms-conditions') dispatch(fetchTermsConditionsPageSettings(response.data?.data));
      }
    } catch (error: any) {

    }
  };
}

export function saveApiSettingsApi(body: any) {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/save`,
        method: 'post',
        data: body

      });
      if (response.data.success) {
        dispatch(addUpdateProductTypeSuccess(response.data.success));
        if (body?.type && body?.type === 'themeColors') {
          dispatch(fetchApiSettingsApi());
        }
        if (body?.type && body?.type !== 'products') dispatch(fetchStaticsPagesContentApi({ page: body?.type }));

        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: response.data.message,
            variant: 'alert',
            alert: {
              color: 'success'
            }
          }));

      }

    } catch (error: any) {
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}

export function saveAppItemsSettingsApi(body: any) {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/pages/items/save`,
        method: 'post',
        data: body

      });
      if (response.data.success) {
        dispatch(addUpdateProductTypeSuccess(response.data.success));
        if (body?.type) dispatch(fetchStaticsPagesContentApi({ page: body?.type }));
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: response.data.message,
            variant: 'alert',
            alert: {
              color: 'success'
            }
          }));

      }

    } catch (error: any) {
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}
export function deleteAppItemsSettingsApi(body: { type: string, appId: string | number, id: number }) {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/pages/items/delete/${body?.id}`,
        method: 'delete',
        data: body
      });
      if (response.data.success) {
        dispatch(addUpdateProductTypeSuccess(response.data.success));
        if (body?.type) dispatch(fetchStaticsPagesContentApi({ page: body?.type }));
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: response.data.message,
            variant: 'alert',
            alert: {
              color: 'success'
            }
          }));

      }

    } catch (error: any) {
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}

export function saveImagesOfStaticsSettingsApi(body: any) {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/image/upload`,
        method: 'post',
        data: body
      });
      dispatch(loadImageSuccessAction(true));

      if (response.data.success) {
        dispatch(getImagesOfStaticsSettingsApi());
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: response.data.message,
            variant: 'alert',
            alert: {
              color: 'success'
            }
          }));

      }

    } catch (error: any) {
      dispatch(loadImageSuccessAction(true));
      if (error && error.message) {
        dispatch(
          openSnackbar({
            open: true,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            message: error.message,
            variant: 'alert',
            alert: {
              color: 'error'
            }
          }));
      }
    }
  };
}

export function getImagesOfStaticsSettingsApi() {
  return async (dispatch: any) => {
    try {
      const response = await axios({
        url: `/api-settings/image/list`,
        method: 'get',
      });
      if (response.data.success) {
        dispatch(fetchImagesOfStaticsSettings(response.data?.data));
      }

    } catch (error: any) {
    }
  };
}


